module.exports = __webpack_public_path__ + "img/s00134.3f17df2f.png";